import { useEffect, useState } from 'react'
import { useApi } from '@/contexts/ApiContext'
import { enrichRenderedServicePricing } from '@/components/Store/StoreUtilities'
import type { RenderedService } from '@/types/interfaces/service-item'

export function useRenderedServices(endpoint: string = 'base') {
    const { apiGet } = useApi()
    const [services, setServices] = useState<RenderedService[]>([])
    const [relatedServices, setRelatedServices] = useState<RenderedService[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        apiGet(`/external/category/${encodeURIComponent(endpoint)}`)
            .then((data) => {
                const normalizeButton = (rs: RenderedService) => {
                    if (rs.button && !rs.button.link && (rs.button as Record<string, string>).url) {
                        rs.button.link = (rs.button as Record<string, string>).url
                    }
                }

                const rendered: RenderedService[] = Array.isArray(data?.raw?.renderedServices)
                    ? data.raw.renderedServices
                    : []
                rendered.forEach((rs) => {
                    normalizeButton(rs)
                    enrichRenderedServicePricing(rs, data.authenticated)
                })
                setServices(rendered)

                const related: RenderedService[] = Array.isArray(data?.raw?.relatedServices)
                    ? data.raw.relatedServices
                    : []
                related.forEach((rs) => {
                    normalizeButton(rs)
                    enrichRenderedServicePricing(rs, data.authenticated)
                })
                setRelatedServices(related)
            })
            .catch((err) => {
                console.error(`Failed to load services from ${endpoint}`, err)
                setServices([])
                setRelatedServices([])
            })
            .finally(() => setLoading(false))
    }, [endpoint, apiGet])

    return { services, relatedServices, loading }
}
